import { render, staticRenderFns } from "./traineePrevTraining.vue?vue&type=template&id=348dae28"
import script from "./traineePrevTraining.vue?vue&type=script&lang=js"
export * from "./traineePrevTraining.vue?vue&type=script&lang=js"
import style0 from "./traineePrevTraining.vue?vue&type=style&index=0&id=348dae28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports